import { CONSTANTS } from '..'

export const filterConditions = {
  [CONSTANTS.FIELDTYPES.DATETIME]: [
    { label: 'Is equal to', value: 'equals' },
    { label: 'Is not equal to', value: 'notEquals' },
    { label: 'Is greater than', value: 'greaterThan' },
    { label: 'Is greater than equals', value: 'greaterThanEquals' },
    { label: 'Is less than', value: 'lessThan' },
    { label: 'Is less than equals', value: 'lessThanEquals' },
  ],
  [CONSTANTS.FIELDTYPES.TEXT]: [
    { label: 'Is equal to', value: 'equals' },
    { label: 'Is not equal to', value: 'notEquals' },
    { label: 'Starts with', value: 'startsWith' },
    { label: 'Ends with', value: 'endsWith' },
    { label: 'Contains', value: 'contains' },
    // { label: 'Has value', value: 'in' },
  ],
  [CONSTANTS.FIELDTYPES.SELECT]: [
    { label: 'Is equal to', value: 'equals' },
    { label: 'Has value', value: 'in' },
    { label: 'Null', value: 'null' },
  ],
  [CONSTANTS.FIELDTYPES.BOOLEAN]: [
    { label: 'Is equal to', value: 'equals' },
    { label: 'Is not equal to', value: 'notEquals' },
    { label: 'Null', value: 'null' },
  ],
  [CONSTANTS.FIELDTYPES.NUMBER]: [
    { label: 'Is equal to', value: 'equals' },
    { label: 'Is not equal to', value: 'notEquals' },
    { label: 'Is greater than', value: 'greaterThan' },
    { label: 'Is greater than equals', value: 'greaterThanEquals' },
    { label: 'Is less than', value: 'lessThan' },
    { label: 'Is less than equals', value: 'lessThanEquals' },
  ],
}

export const defaultFilterConditionValue = 'equals'
